var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2650",
    "data-name": "Group 2650",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 15.064,
    viewBox: "0 0 18 15.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1772",
    "data-name": "Rectangle 1772",
    width: 18,
    height: 15.064,
    transform: "translate(0 0)",
    fill: "#474747"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2649",
    "data-name": "Group 2649",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M.34,6.786A.928.928,0,0,0,.93,7h4.4a.93.93,0,0,0,0-1.861H3.279L4.972,3.545l.021-.021a5.671,5.671,0,0,1,9.359,2.117.93.93,0,1,0,1.754-.62A7.531,7.531,0,0,0,3.687,2.2L1.861,3.916V1.666A.93.93,0,0,0,0,1.666v4.4c0,.009,0,.018,0,.026s0,.036,0,.054,0,.025,0,.038,0,.035.008.053,0,.024.008.036.009.036.014.053l.01.033c.006.018.013.037.02.055l.012.028c.008.019.017.037.027.056l.013.024c.011.019.021.037.033.055L.168,6.6c.013.018.025.035.039.053l.016.019c.01.012.019.023.029.035l.016.015.016.016c.017.017.035.033.054.049h0",
    transform: "translate(0 0)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M31,66.013V66q0-.045,0-.089v-.008c0-.028-.007-.055-.013-.082l0-.011c-.005-.026-.012-.051-.02-.077l0-.013c-.008-.025-.017-.049-.027-.073l-.005-.013q-.015-.035-.033-.068l-.007-.013q-.018-.032-.038-.063l-.01-.015q-.02-.029-.042-.056l-.015-.017c-.01-.011-.018-.023-.029-.034l-.017-.016-.016-.016c-.017-.016-.034-.032-.051-.046l-.014-.011c-.019-.015-.039-.03-.059-.044l-.012-.008c-.021-.014-.042-.027-.064-.039l-.016-.008c-.021-.011-.043-.022-.064-.031l-.024-.009-.06-.022-.032-.009-.054-.014-.037-.007-.052-.008-.039,0-.053,0H25.67a.93.93,0,1,0,0,1.861h2.051l-1.69,1.586-.022.021A5.634,5.634,0,0,1,22,70.209h0A5.634,5.634,0,0,1,17.99,68.55a5.7,5.7,0,0,1-1.339-2.122.93.93,0,0,0-1.754.62,7.575,7.575,0,0,0,1.779,2.819A7.482,7.482,0,0,0,22,72.069H22a7.482,7.482,0,0,0,5.313-2.2l1.826-1.714v2.251a.93.93,0,0,0,1.861,0V66.041c0-.01,0-.019,0-.029",
    transform: "translate(-13.001 -57.005)",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrow);
export default __webpack_public_path__ + "static/media/round_arrow.5d47d764409745af3c76e5b7d080ca6c.svg";
export { ForwardRef as ReactComponent };